import { termsService } from '../../services'

function getTerms() {
  return () => termsService.getTerms()
}

export default {
  getTerms,
}
